import { styled } from '@mui/material';

export const Wrapper = styled('div')`
    display: flex;
    align-items: center;
    &.table-cell-sortable {
        display: inline-block;
        span,
        svg {
            vertical-align: middle;
        }
        &.no-data {
            pointer-events: none;
        }
    }
    .sortableCell {
        svg {
            opacity: 0.3;
        }
    }
    .sortIcons {
        width: 24px;
        height: 24px;
        position: relative;
        display: inline-block;
        &_ASC {
            .sortIcons_up {
                opacity: 1;
            }
        }
        &_DESC {
            .sortIcons_down {
                opacity: 1;
            }
        }
        &_up {
            top: -3px;
        }
        &_down {
            top: 3px;
        }
        svg {
            position: absolute;
            left: 0;
            right: 0;
            margin: auto;
        }
    }
`;
